/* eslint-disable no-console */
/* eslint-disable prefer-template */
import axios from 'axios';
import { config } from '../config/config';
import { localStorageNameEnum } from '../models/constants';

/*
    This service returns only two variants of the result:

      1) In case of successful result:
      {
        value: <returned value>,
      }

      2) When something goes wrong:
      {
        error: <error message>,
      }
 */

/**
 * @param {{
 *  url: string;
 *  options?: any;
 *  token?: string;
 *  dispatchGlobalState: () => void | undefined;
 * }} props
 */
export const httpService = async ({
  url,
  options,
  token,
  dispatchGlobalState,
}) => {
  const storedToken = localStorage.getItem(localStorageNameEnum.AUTH_TOKEN);
  const { data, method } = options;

  const headers = {
    'Content-Type': 'application/json',
  };

  if (token !== undefined) {
    headers.Authorization = `Bearer ${token}`;
  } else if (storedToken) {
    headers.Authorization = `Bearer ${storedToken}`;
  }

  try {
    const response = await axios({
      url: `${config.API_URL}${url}`,
      method,
      headers,
      data,
    });

    const json = response.data;
    if (json?.error) {
      throw new Error(json.error.message);
    }

    return {
      value: json,
    };
  } catch (error) {
    if (error.response) {
      const {
        status,
        headers: responseHeaders,
        data: responseData,
      } = error.response;

      if (status === 401) {
        if (dispatchGlobalState) {
          dispatchGlobalState({ type: 'LOGOUT' });
        }

        return {
          error: 'Session expired',
        };
      }

      const isJson =
        responseHeaders['content-type']?.includes('application/json');
      if (isJson && responseData) {
        return {
          error: String(error.message).replace(/Error:/g, ''),
          // error: 'Network error'
        };
        // throw new Error(
        //   `${status ?? ''} ${responseData?.message || error.message}`
        // );
      }

      return {
        error: String(error.message).replace(/Error:/g, ''),
        // error: 'Network error'
      };
      // throw new Error(JSON.stringify(error.response));
    }

    return {
      error: String(error.message).replace(/Error:/g, ''),
      // error: 'Network error'
    };
  }
};
